import { Link } from "react-router-dom";
import styled from "styled-components";

export const Wrapper = styled("div")(({theme}) => ({
	display: "flex",
	flexDirection: "column",
	width: "100%",
	maxWidth: 900,
	margin: "40px auto",

	"& > div": {
		fontSize: "15px",
		lineHeight: "24px",
	},

	[theme.down("md")]: {
		maxWidth: 700,
	},

	[theme.down("sm")]: {
		maxWidth: 500,
	},

	[theme.down("xs")]: {
		width: "100%",
		padding: "0px 20px",
	},
}));

export const PublicOfferContent =styled("div")(({theme}) => ({}));

export const PublicOfferTitle = styled("h4")(({theme}) => ({
	fontSize: 20,
	fontWeight: 700,
	textTransform: "uppercase",
	textAlign: "center",
	lineHeight: 2,
}));

export const PublicOfferDate = styled("div")(({theme}) => ({
	margin: "32px 0",
}));

export const City = styled("p")(({theme}) => ({

}));

export const Date = styled("p")(({theme}) => ({

}));

export const PublicOfferInfo = styled("div")(({theme}) => ({
	"& a": {
		color: theme.palette.error,
	},

	"& a:hover": {
		textDecoration: "underline",
	},
}));

export const PublicOfferInfoTitle = styled("h4")(({theme}) => ({
	marginTop: 32,
	marginBottom: 16,
	fontSize: 20,
	fontWeight: 700,

}));

export const PublicOfferContentLink = styled("ul")(({theme}) => ({
	listStyleType: "'-'",
}));

export const PublicOfferContentLinkComponent = styled("li")(({theme}) => ({
	marginLeft: 5,
	paddingTop: 5,

	"&:firstChild(1)": {
		paddingTop: 0,
	}
}));

export const RequisitesTable = styled("table")(({ theme }) => ({
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "16px",
  fontSize: "15px",

  "& tr": {
    borderBottom: `1px solid ${theme.palette.borderLight}`,
  },

  "& td": {
    padding: "10px 12px",
    verticalAlign: "top",
    lineHeight: "1.5",
  },

  "& td:first-child": {
    fontWeight: 600,
    color: theme.palette.textPrimary,
    whiteSpace: "nowrap",
    width: "40%",
  },

  "& td:last-child": {
    color: theme.palette.textSecondary,
  },

  "& a": {
    color: `${theme.palette.error} !important`,
  },

  [theme.down("xs")]: {
    "& td:first-child": {
      whiteSpace: "normal",
      width: "45%",
    },
  },
}));

export const LinkItem = styled((props) => (
		<Link {...props} />
))(({ theme }) => ({
	color: theme.palette.error,
	transition: "all .5s ease-out",

	"&:hover": {
		textDecoration: "underline",
	},
}));